import _ from 'lodash';
import {
    FETCH_JOKL_USERS,
    CLEAN_JOKL_USERS,
    CHANGE_JOKL_USER_STATUS,
} from './types';
import { request, __ } from '../functions';

export const fetchJoklUsers = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/jokl/users', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_JOKL_USERS, payload: data });
    });
};

export const changeJoklUserStatus = (screen, id, s) => {
    return dispatch => request(`/jokl/changeUserStatus/${id}/${s}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť stav'));
            return;
        }

        screen.showSnackbar('success', __('Stav bol zmenený'));

        dispatch({ type: CHANGE_JOKL_USER_STATUS, payload: { id, status: s } });
    });
};

export const cleanJoklUsers = () => ({ type: CLEAN_JOKL_USERS });
